import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Label, TextInput } from "flowbite-react";
import useAPI from "hooks/useAPI";
import MirumModal from "components/MirumModal";
import MirumFormikErrorMsg from "components/Creation/components/MirumFormikErrorMsg";
import moment from "moment";
const DetailsModal = ({ email, onDetailsSubmitted, show, onDidDismiss }) => {
  const { API } = useAPI({});
  const DetailsSchema = Yup.object().shape({
    name: Yup.string()
      .min(2)
      .typeError("Please enter a valid name.")
      .required("Required"),
    mobileNumber: Yup.number()
      .typeError("Please enter a valid phone number.")
      .required("Required"),
    // dob: Yup.string().required("Required"),
    dob: Yup.string()
      .required("Required")
      .test("dob-1", "Invalid date of birth", (value) => {
        console.log("value: ", value);
        if (!value) return false;
        const date = moment(value, "DD/MM/YYYY");
        if (!date.isValid()) return false;
        return true;
      })
      .test("dob-2", "You must be at least 18 years old", (value) => {
        console.log("value: ", value);
        if (!value) return false;
        const date = moment(value, "DD/MM/YYYY");
        if (!date.isValid()) return false;
        const today = moment();
        const age = today.diff(date, "years");
        console.log("age: ", age);
        if (age < 18) return false;
        return true;
      }),
    marketingAccepted: Yup.boolean(),
  });

  const submit = async (values) => {
    try {
      const data = await API.put(`/user/details`, values);
      console.log("data: ", data);
      onDetailsSubmitted && onDetailsSubmitted();
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: null,
      mobileNumber: null,
      dob: null,
      marketingAccepted: false,
    },
    validateOnMount: true,
    validationSchema: DetailsSchema,
    onSubmit: submit,
  });

  const { name, mobileNumber, dob } = formik.values;

  return (
    <MirumModal
      show={show}
      onDidDismiss={onDidDismiss}
      positiveBtnBody="done"
      onPositiveBtnClick={formik.handleSubmit}
      disablePositiveBtn={Object.keys(formik.errors).length > 0}
    >
      <div>
        <h1 className="mb-4 lowercase">Your details</h1>
        <p className="lowercase">
          Hey, you're new! Please fill in your details below:
        </p>

        <div className="text-left pb-4">
          <form onSubmit={formik.handleSubmit}>
            <div className="my-4">
              <div>
                <Label htmlFor="email" value="email" />
              </div>
              <div>
                <p className="text-sm text-gray-500">{email}</p>
                {/* <TextInput
                  id="email"
                  type="email"
                  value={email}
                  required={true}
                  disabled={true}
                /> */}
              </div>
            </div>
            <div className="my-4">
              <div>
                <Label htmlFor="name" value="name" />
              </div>
              <TextInput
                id="name"
                type="text"
                className="mirum-text-field"
                value={name}
                onChange={formik.handleChange}
                required={true}
              />
              <MirumFormikErrorMsg
                formik={formik}
                formikKey="name"
                name="name"
              />
            </div>
            <div className="my-4">
              <div>
                <Label htmlFor="mobileNumber" value="mobile number" />
              </div>
              <TextInput
                id="mobileNumber"
                type="tel"
                className="mirum-text-field"
                value={mobileNumber}
                onChange={formik.handleChange}
                required={true}
              />
              <MirumFormikErrorMsg
                formik={formik}
                formikKey="mobileNumber"
                name="Phone Number"
              />
            </div>
            <div className="my-4">
              <div>
                <Label htmlFor="dob" value="date of birth (dd/mm/yyyy)" />
              </div>
              <TextInput
                id="dob"
                type="text"
                className="mirum-text-field"
                value={dob}
                onChange={(e) => {
                  console.log("e", e.target.value);
                  let value = e.target.value;
                  value = value
                    .replace(/^(\d\d)(\d)$/g, "$1/$2")
                    .replace(/^(\d\d\/\d\d)(\d+)$/g, "$1/$2")
                    .replace(/[^\d\/]/g, "");
                  formik.setFieldValue("dob", value);
                }}
                required={true}
                placholder="DD/MM/YYYY"
              />
              <MirumFormikErrorMsg formik={formik} formikKey="dob" name="DOB" />
            </div>
            <div className="my-4">
              <div>
                <Label htmlFor="marketing" value="marketing communications" />
              </div>
              <div className="flex gap-2 items-center cursor-pointer">
                <input
                  type="checkbox"
                  id="marketing"
                  onChange={(e) => {
                    formik.setFieldValue("marketingAccepted", e.target.checked);
                  }}
                />
                <label htmlFor="marketing">
                  keep me in the loop about all things mirum
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </MirumModal>
  );
};

export default DetailsModal;
